import api from './index';
import { INSTITUTIONS_LIST_PER_PAGE_ITEMS } from '../../app.config.vars/stored';
export const mapInstitutionsResponse = (response) => response.data.map((institutionItem) => ({
    id: institutionItem.institution.id,
    name: institutionItem.institution.name,
    email: institutionItem.email,
    isActive: institutionItem.isActive,
    approvalStatus: institutionItem.institution.approvalStatus,
    newDocument: institutionItem.institution.newDocument,
    editorCount: institutionItem.institution.editorCount ?? 0,
}));
const endpoints = {
    institutions: '/admin/institutions',
};
export const getInstitutions = async (currentPage) => {
    const res = await api.get(endpoints.institutions, {
        params: {
            page: currentPage,
            limit: INSTITUTIONS_LIST_PER_PAGE_ITEMS,
        },
    });
    return res.data;
};
export const getInstitution = async (id) => {
    const res = await api.get(`${endpoints.institutions}/${id}`);
    return res.data;
};
export const addInstitution = async (body) => {
    return await api.post(endpoints.institutions, body);
};
export const updateInstitution = async (id, body) => {
    return await api.patch(`${endpoints.institutions}/${id}`, body);
};
export const deleteInstitution = async (id) => {
    return await api.delete(`${endpoints.institutions}/${id}`);
};
